<div>
  <div class="mb-2" *ngIf="canEdit">
    <button
      class="btn btn-raised btn-primary mr-2"
      (click)="showNew = !showNew"
      type="button"
    >
      New item
    </button>
    <button
      class="btn btn-raised btn-secondary mr-2"
      (click)="open(content)"
      type="button"
    >
      Bulk add
    </button>
  </div>

  <!-- Inline form for new items with attributes -->
  <div *ngIf="showNew && hasCustomListAttributes" class="card mb-3">
    <div class="card-body">
      <h6>New Item</h6>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Text</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newItem.text"
              placeholder="Display text"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Value</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newItem.value"
              placeholder="Value"
            />
          </div>
        </div>
      </div>
      <div class="row" *ngFor="let attr of attributes">
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ attr.name }}</label>
            <input
              type="text"
              class="form-control"
              [ngModel]="getNewItemAttributeValue(attr.id)"
              (ngModelChange)="setNewItemAttributeValue(attr.id, $event)"
              [placeholder]="attr.name"
            />
          </div>
        </div>
      </div>
      <button
        type="button"
        class="btn btn-success mr-2"
        (click)="addNewItem()"
      >
        Add Item
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="cancelNewItem()"
      >
        Cancel
      </button>
    </div>
  </div>

  <!-- Standard editor for items without attributes -->
  <wm-list-item-editor
    *ngIf="showNew && !hasCustomListAttributes"
    #editor
    [item]="newItem"
    (save)="addItem($event, editor)"
    [showImageEditor]="showImageEditor"
  ></wm-list-item-editor>

  <div class="mt-3">
    <div *ngIf="listItems && listItems.length > 0">
      <p class="text-muted" *ngIf="canEdit">Click and drag to reorder</p>
      <p class="text-muted" *ngIf="isRoleMembersList">Associate images with the Role Members listed below by clicking the edit icon.</p>

      <!-- Table view if attributes exist -->
      <div *ngIf="hasCustomListAttributes" class="table-responsive">
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Text</th>
              <th>Value</th>
              <th *ngFor="let attr of attributes">{{ attr.name }}</th>
              <th *ngIf="canEdit">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listItems">
              <td>{{ item.text }}</td>
              <td>{{ item.value }}</td>
              <td *ngFor="let attr of attributes">
                <input
                  *ngIf="canEdit"
                  type="text"
                  class="form-control form-control-sm"
                  [ngModel]="getAttributeValue(item, attr.id)"
                  (ngModelChange)="setAttributeValue(item, attr.id, $event)"
                />
                <span *ngIf="!canEdit">{{ getAttributeValue(item, attr.id) }}</span>
              </td>
              <td *ngIf="canEdit">
                <i
                  class="material-icons"
                  style="cursor: pointer;"
                  (click)="currentItem = item.id"
                  ngbTooltip="Edit List Item"
                >
                  create
                </i>
                <i
                  *ngIf="!isRoleMembersList"
                  class="material-icons"
                  style="cursor: pointer;"
                  (click)="removeItem(item)"
                  ngbTooltip="Delete List Item"
                >
                  delete
                </i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Original card view if no attributes -->
      <div
        *ngIf="!hasCustomListAttributes"
        dragula="listEditor"
        [(dragulaModel)]="listItems"
        (dragulaModelChange)="emitChange()"
        style="cursor: move;"
      >
        <div *ngFor="let item of listItems" class="mb-2">
          <div class="card card-sm card-grey" *ngIf="currentItem !== item.id">
            <div class="card-body">
              <div class="card-title">
                {{ item.text || item.value }}

                <div class="float-right">
                  <i
                    *ngIf="canEdit || isRoleMembersList"
                    class="material-icons"
                    style="cursor: pointer;"
                    (click)="currentItem = item.id"
                    ngbTooltip="Edit List Item"
                  >
                    create
                  </i>
                  <i
                    *ngIf="canEdit && !isRoleMembersList"
                    class="material-icons"
                    style="cursor: pointer;"
                    (click)="removeItem(item)"
                    ngbTooltip="Delete List Item"
                  >
                    delete
                  </i>
                </div>
              </div>
            </div>
          </div>

          <wm-list-item-editor
            [item]="item"
            title="Edit list item"
            saveText="Apply"
            *ngIf="currentItem === item.id"
            (save)="saveItem()"
            [imageEditOnlyMode]="isRoleMembersList"
            [showImageEditor]="showImageEditor"
          ></wm-list-item-editor>
        </div>
      </div>

      <!-- Edit modal for table view with attributes -->
      <div *ngIf="currentItem && hasCustomListAttributes && getCurrentItem()" class="card mb-3">
        <div class="card-body">
          <h6>Edit Item</h6>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Text</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="getCurrentItem().text"
                  placeholder="Display text"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Value</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="getCurrentItem().value"
                  placeholder="Value"
                />
              </div>
            </div>
          </div>
          <div class="row" *ngFor="let attr of attributes">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ attr.name }}</label>
                <input
                  type="text"
                  class="form-control"
                  [ngModel]="getAttributeValue(getCurrentItem(), attr.id)"
                  (ngModelChange)="setAttributeValue(getCurrentItem(), attr.id, $event)"
                  [placeholder]="attr.name"
                />
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-success mr-2"
            (click)="saveItem()"
          >
            Save
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            (click)="currentItem = null"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
    <p *ngIf="!listItems || listItems.length < 1" class="text-muted">
      There are no list items.
    </p>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-bulk-title">Bulk add list items</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label class="bmd-label-static" for="bulkAdd">
          List items
        </label>
        <textarea
          class="form-control"
          name="bulkAdd"
          id="bulkAdd"
          rows="3"
          aria-describedby="bulkHelpBlock"
          [(ngModel)]="bulkAddText"
        ></textarea>
        <small id="bulkHelpBlock" class="form-text text-muted">
          Comma separated list of values
        </small>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-dark"
      (click)="modal.close('Save click')"
    >
      Add
    </button>
  </div>
</ng-template>
